/* eslint-disable no-prototype-builtins */
var XPortal = XPortal || {};

function XpandUploadControl(container, domel, modelName, isInlineEditor = false, dropZone) {
    var self = this;
    self.container = container;
    self.uploadElement = domel.parent().find(".xpand-upload-val");
    self.element = domel.find(".files").first();
    self.modelName = modelName;
    if (!self.element.length) self.element = domel;
    self.isInlineEditor = isInlineEditor;
    self.isDarkTheme = document.body.classList.contains('theme-dark');
    self.errorBuffer = [];

    if (self.kendoUpload) self.kendoUpload.destroy();
    self.kendoUpload = self.element.kendoUpload(self.GetUploadOptions()).data("kendoUpload");
    self.ValueControl = self.settings.valueControlSelector ? self.ValueControl = $(self.settings.valueControlSelector) : self.element;
    self.kendoUpload._showUploadButton = function () { }; //don't show default kendo upload buttons for now
    // self.kendoUpload._showHeaderUploadStatus = function () { }; //don't show upload status
    self.SetupDropZone(dropZone);
    const relGrid = self.uploadOptions.dropZone ? $('#' + $(self.uploadOptions.dropZone).children('.k-dropzone').attr("data-related-grid-selector")) : [];
    self.relatedKGrid = (relGrid.length < 1) ? self.relatedKGrid : XPortal.Grid.GetGridInfo(relGrid);

    self.RegisterForEvents();
    XPortal.Utils.MarkVisited({ Element: domel });
    if (self.settings.autoUpload) self._setupInlineControl();

    var $elem = $(self.element[0]);
    self.DownloadAllLink($elem);
    self.UpdateUploadCustomFileNames($elem);
    if (!dropZone || !dropZone.length) {
        self.uploadElement.bind("dispatchFieldEvent", function (e) {
            var files = self.kendoUpload.getFiles();
            var names = files.map(f => f.dst).join(self.settings.valueSeparator);

            XPortal.Store.FieldEvent(self.uploadElement, names, self.modelName, self.settings);
        });

        XPortal.Store.Subscribe({ Model: modelName, Field: self.settings.fieldname, Target: self.uploadElement }, function render(value) {
            self.SetCurrentValue();
        });
    }
    if (self.isInlineEditor && self.kendoUpload && self.kendoUpload.element)
        self.kendoUpload.element.removeAttr("data-show-file-list");
}

XpandUploadControl.prototype._setupInlineControl = function () {
    const iself = this;
    iself._setupInlineFilesDropDown();

    iself.OnSuccess = function (e) {
        const oself = this;
        oself._setupInlineFilesDropDown();
        oself.SetCurrentValue();
        oself.ValueControl.attr("data-changed", true);
    };
    iself.OnError = function (e) {
        iself.hasUploadError = true;
    };
    iself.OnComplete = function (e) {
        if (iself.hasUploadError) {
            if (iself.errorBuffer.length) {
                iself.settings.localization.filesUploadedErrorMessage = iself.errorBuffer.join('\n');
            }
            XPortal.Modal.alert({
                headerText: iself.settings.localization.filesUploadedErrorTitle || "Upload error",
                alertText: iself.settings.localization.filesUploadedErrorMessage || "Failed to upload file(s). Contact the portal administrator for details."
            });
            iself.hasUploadError = false;
            iself.errorBuffer = [];
        }
    };
};

XpandUploadControl.prototype._setupInlineFilesDropDown = function () {
    const self = this;
    if (self.ValueControl && self.ValueControl.parent().hasClass('inlineUploadEditor')) {
        self.ValueControl.closest('td.k-edit-cell').css('overflow', 'visible');
    }
};

XpandUploadControl.prototype._collectServerErrors = function (e) {
    if (!e || !Array.isArray(e.Files)) return [];

    const msgs = [];
    e.Files.forEach(f => {
        if (!f) return;

        const prefix = f.src ? (f.src + ': ') : '';
        const err = f.error;
        if (!err) return;
        if (Array.isArray(err) && err.length) msgs.push(prefix + err.join(';'));
    });

    return msgs;
};

XpandUploadControl.prototype._setUploadError = function (e) {
    const self = this;
    self.hasUploadError = true;
    if (e && e.trim())
        self.settings.localization.filesUploadedErrorMessage = e;
};

XpandUploadControl.prototype.SetupDropZone = function (dropZone) {
    //drag n drop workaround
    const iself = this;
    iself.counter = 0;
    if (!dropZone || !dropZone.length) {
        dropZone = $(iself.kendoUpload.options.dropZone);
        if (!dropZone.length) dropZone = iself.kendoUpload.element.closest(".k-dropzone");
    }
    if (dropZone.length === 0) return;
    dropZone.on('dragenter', function () {
        var dropSeparator = $.find(".dropzone-container-separator,.dropzone-container-separator-border");
        $(dropSeparator).each(function (i) {
            $(this).addClass('k-dropzone-hovered');
        });

        if (dropZone.data("counter") === 0) {
            iself.counter = 0;
            dropZone.removeData("counter");
            //console.log('counter drop' +iself.counter);
        }
        if (iself.counter++ === 0) {
            console.log('entered the page' + iself.counter);
        }
    }).on('dragleave', function () {

        if (--iself.counter === 0) {
            console.log('left the page ' + iself.counter);
            iself.ClearDropZone();
        }
    });
};

XpandUploadControl.prototype.ClearDropZone = function (el, e) {
    var hovered = $.find(".k-dropzone-hovered");
    $(hovered).each(function (i) {
        $(this).removeClass('k-dropzone-hovered');
    });
};

XpandUploadControl.prototype.SetCurrentValue = function (xval) {
    const iself = this;
    if (xval == null) {
        var files = iself.kendoUpload.getFiles();
        xval = files.map(f => f.dst).filter(n => n).join(iself.settings.valueSeparator);
    }
    iself.ValueControl.val(xval);
    iself.uploadElement.trigger('editformcontrol');
};
XpandUploadControl.prototype.GetCurrentValue = function () {
    const iself = this;
    const r = iself.ValueControl.val() || "";
    if (r.length) return r.split(iself.settings.valueSeparator);
    return [];
};

XpandUploadControl.ParseControlAttributes = function (el) {
    var fls = [];
    var isMultiSelect = el.hasClass("xpand-multiselect");
    var valueControlSelector = el.attr("data-value-id");
    if (el.attr("data-value")) {
        $(el.attr("data-value").split(el.attr("data-val-separator"))).each(function (ix, d) {
            if (d && d != "" && d.trim() != "" && isNaN(Number(d))) fls.push({
                name: d,
                size: null,
                dst: d,
                extension: d.split('.').pop(),
                existing: 1
            });
        });
    }
    var sttgs = XPortal.Main.GetSettingsFor(el);
    sttgs.ismultiselect = isMultiSelect;
    sttgs.isenabled = sttgs.editable;
    sttgs.saveUrl = sttgs.src;
    sttgs.removeUrl = sttgs["rem-src"];
    sttgs.downloadUrl = sttgs.download;
    sttgs.localization = {
        select: sttgs["title-select"],
        uploadSelectedFiles: sttgs["title-upload"],
        clearSelectedFiles: sttgs["title-clear"],
        dropFilesHere: sttgs["title-drop"],
        headerStatusUploaded: sttgs["title-done"],
        headerStatusUploading: sttgs["title-ping"],
        filesUploadedTitle: sttgs["title-uploaded-caption"],
        filesUploadedMessage: sttgs["title-uploaded-message"],
        filesUploadedErrorTitle: sttgs["title-upload-error"],
        filesUploadedErrorMessage: sttgs["title-upload-error-message"],
        filesUploadingNotAllowedMessage: sttgs["title-notallowed"],
    };

    sttgs.files = fls;
    let dsel = sttgs["dropzone-selector"];
    dsel = dsel ? (dsel.startsWith("#") ? dsel.replace("##", "#") : "#" + dsel) : dsel;
    sttgs.dropzone = dsel ? dsel : el.closest(".upload-file-container");
    sttgs.valueControlSelector = '#' + valueControlSelector;
    sttgs.fileTemplate = '#fileTemplate_' + valueControlSelector;
    sttgs.showFileList = el.data().hasOwnProperty("showFileList") ? el.data().showFileList : true;
    sttgs.autoUpload = el.data().hasOwnProperty("autoupload") ? el.data().autoupload : true;

    return sttgs;
};

XpandUploadControl.prototype.GetUploadOptions = function () {
    var self = this;
    self.settings = XpandUploadControl.ParseControlAttributes(self.element);
    var sttgs = self.settings;
    var fileCount = 0;
    var $dropzone = $(self.element).closest(".dropzone-container");
    var maxFileCount = Number($(self.element).attr('data-max-file-count'));
    var maxFilesPerUpload = Number($(self.element).attr('data-max-files-per-upload'));

    self.uploadOptions = {
        hasUploadError: false,
        multiple: sttgs.ismultiselect,
        enabled: sttgs.isenabled,
        async: {
            saveField: sttgs.saveField ? sttgs.saveField : "files",
            removeField: sttgs.removeField ? sttgs.removeField : "files",
            saveUrl: sttgs.saveUrl,
            removeUrl: sttgs.removeUrl,
            autoUpload: sttgs.autoUpload,
            batch: false,
            concurrent: false
        },
        dropZone: sttgs.dropzone,
        localization: sttgs.localization,
        fieldsnames: sttgs.fieldsnames,
        upload: function (e) {
            XPortal.Loader.show({ showOverlay: true, overlayBgColor: "rgba(27, 27, 27, 0.4)" }).show();
            fileCount = 0;
            // XPortal.Loader.message({ 'selector': null, showOverlay: true }, 'Uploading...');
        },
        validateTypeSize: function (e) {
            const $elem = self.kendoUpload.element;
            const allowedTypes = self.GetAttr('accept', 'data-val-uploadtype-types') || '';
            const fileSizeBytes = (Number(self.GetAttr('filesize', 'data-val-uploadsize-max') ? self.GetAttr('filesize', 'data-val-uploadsize-max') : self.settings.filesize)) * 1000;
            const files = e.files;
            let res = true;

            $.each(files, function () {
                if (allowedTypes && allowedTypes !== '') {
                    var allowedTypesArray = allowedTypes.toString().toLowerCase().split(',');
                    if (!allowedTypesArray.includes(this.extension.toLowerCase())) {
                        e.preventDefault();
                        res = false;
                        XPortal.Modal.alert({
                            headerText: $elem.data('title-upload-error'),
                            alertText: self.GetAttr('data-val-uploadtype', 'data-not-allowed-files-text') || ""
                        });
                    }
                }
                if (!isNaN(fileSizeBytes) && fileSizeBytes > 0) {
                    if (this.size > fileSizeBytes) {
                        e.preventDefault();
                        res = false;
                        XPortal.Modal.alert({
                            headerText: $elem.data('title-upload-error'),
                            alertText: self.GetAttr('data-val-uploadsize', 'data-size-exceeded-file-text') || ""
                        });
                    }
                }
                if (self.modelName && XPortal.Store.GetModelByName(self.modelName) && XPortal.Store.GetModelByName(self.modelName).entity.IsCreating) {
                    e.preventDefault();
                    res = false;
                    self.hasUploadError = true;
                    XPortal.Modal.alert({
                        headerText: self.settings.localization.filesUploadedErrorTitle || "Upload error",
                        alertText: self.settings.localization.filesUploadingNotAllowedMessage || "Failed to upload file(s). Please save the page before."
                    });
                }
            });
            return res;
        },
        select: function (e) {
            var $elem = self.kendoUpload.element;
            self.uploadOptions.validateTypeSize(e);
            self.errorBuffer = [];
            e.files.forEach(e => { e.extension = e.extension.replace('.', ''); });

            var dropZone = $(self.kendoUpload.options.dropZone);
            dropZone.data("counter", 0);
            self.UploadingCount = e.files && e.files.length ? e.files.length : 0;
            self.clearCountError($dropzone);
            $elem.closest(".cmnt-edit-form").find(".field-validation-error").remove();

            if (maxFilesPerUpload && e.files.length > maxFilesPerUpload) {
                e.preventDefault();

                XPortal.Modal.alert({
                    headerText: $elem.data('title-upload-error'),
                    alertText: self.GetAttr('data-max-files-per-upload-exceeded-text') || ""
                });
                return;
            }

            // Check current file count
            fileCount += e.files.length;
            if (maxFileCount && fileCount > maxFileCount) {
                e.preventDefault();
                fileCount -= e.files.length;
                let errorMessage = '';

                XPortal.Localization.GetLocalizedStrings('XFAdvanceComments.ErrorMaxCount').then(function (items) {
                    let dictionary = items["XFAdvanceComments.ErrorMaxCount"];
                    errorMessage = XPortal.Template.TemplateToHtml({ maxFileCount }, dictionary);
                    $dropzone.append(`<div class="field-validation-error"> ${errorMessage} </div>`);
                });

                return;
            }

            self.ClearDropZone();
            self.UpdateUploadCustomFileNames($elem);
            self.updateDropzoneClass($dropzone, fileCount);

            var fileInfos = e.files;
            var wrapper = this.wrapper;

            fileInfos.forEach(function (fileInfo) {
                setTimeout(function () {
                    self.addPreview(fileInfo, wrapper);
                });
            });
        },
        complete: function (e) {
            XPortal.Loader.hide({ showOverlay: true });
            if (typeof self.OnComplete === 'function') self.OnComplete(e);
        },
        progress: function (e) {
        },
        success: function (e) {
            let hasServerUploadErrors = false;

            $.each(e.response.Files, function (i, element) {
                if (element.error.length > 0) {
                    hasServerUploadErrors = true;
                    e.files = jQuery.grep(e.files, function (value) {
                        return value.name != element.src;
                    });
                    self.kendoUpload._removeFile(function (file) {
                        return file[0].name == element.src;
                    }, false);
                }
            });
            if (hasServerUploadErrors) {
                const srvMsgs = self._collectServerErrors(e.response);
                if (srvMsgs.length) self.errorBuffer.push(...srvMsgs);
                self._setUploadError(srvMsgs.join('\n'));
            }
            var result = !e.files || (e.files.length < 1 || !(e.response) || !e.response.Files || e.response.Files < 1) ? null : _.map(e.files, function (f) {
                var fnamelcase = $("<div>&nbsp;</div>").html(f.name).text().toLowerCase();
                f.response = _.find(e.response.Files, function (df) {
                    return df.src.toLowerCase() == fnamelcase;
                });
                f.dst = !(f.response) ? null : f.response.dst;
                if (f.dst && f.dst.length > 0) {
                    f.existing = 1;
                    XPortal.UploadFiles.UpdateGridRow(e, f);
                }
                return f;
            });
            var files = self.kendoUpload.getFiles();
            const $commentForm = e.sender.element.closest(".cmnt-edit-form");
            if (e.operation === "upload") {
                const isAllFilesUploaded = files.filter(f => f.dst).length === files.length;
                if ($commentForm.length) {

                    XPortal.Comments.SaveAttachments(e, $commentForm, isAllFilesUploaded, () => self.kendoUpload.clearAllFiles());
                }
                if (!isAllFilesUploaded) return;
            } else {
                files = files.filter(f => f.dst);
                if (e.operation === "remove" && e.files && e.files.length)
                    files = files.filter(x => e.files.find(y => y.uid === x.uid) == null);
            }

            self.element.trigger("success-" + e.operation);
            if (typeof (self.OnSuccess) === "function") self.OnSuccess(e);

            self.kendoUpload.clearAllFiles();
            if (!$commentForm.length) {
                files.filter(f=>f.rawFile).forEach(f => f.justUploaded = true);
                self.kendoUpload._renderInitialFiles(files);
                self.UpdateUploadCustomFileNames(self.kendoUpload.element);

                var names = files.map(f => f.dst).join(self.settings.valueSeparator);

                clearTimeout(self.tinterval);
                self.tinterval = setTimeout(function () {
                    self.SetCurrentValue(names);
                    if (!self.isInlineEditor) {
                        self.uploadElement.trigger("dispatchFieldEvent");
                    }
                }, 500);
            }
        },
        remove: function (e) {
            fileCount -= e.files.length;
            self.updateDropzoneClass($dropzone, fileCount);
            self.clearCountError($dropzone);
        },
        error: function (e) {
            if (typeof (self.OnError) === "function") self.OnError(e);
            self.updateDropzoneClass($dropzone, fileCount);
        },
        files: sttgs.files,
        showFileList: sttgs.showFileList
    };
    if (sttgs.fileTemplate && $(sttgs.fileTemplate).length)
        self.uploadOptions.template = kendo.template($(sttgs.fileTemplate).html());
    if (self.container && self.container.GetUploadOptions)
        return self.container.GetUploadOptions(self, self.uploadOptions);
    return self.uploadOptions;
};

XpandUploadControl.prototype.addPreview = function (file, wrapper) {
    var raw = file.rawFile;
    var fileType = file.extension.toLowerCase().replace('.', '');

    var customFileTypes = ['csv', 'doc', 'docx', 'pdf', 'svg', 'txt', 'xls', 'xlsx'];

    if (raw && raw.type.startsWith("image/")) {

        var reader = new FileReader();
        reader.onloadend = function () {
            var preview = $("<img class='upload-image-preview'>").attr("src", this.result);
            wrapper.find(".k-file[data-uid='" + file.uid + "'] .k-file-group-wrapper")
                .replaceWith(preview);
        };
        reader.readAsDataURL(raw);
    } else if (customFileTypes.includes(fileType)) {

        var rootUrl = `${window.location.protocol}//${window.location.host}/`;
        var iconUrl = `${rootUrl}/content/images/icons/file_types/file_type_${fileType}.svg`;
        var iconPreview = $("<img class='file-icon-preview__img'>").attr("src", iconUrl);
        var iconWrapper = $("<div class='file-icon-preview'>").append(iconPreview);
        wrapper.find(".k-file[data-uid='" + file.uid + "'] .k-file-group-wrapper")
            .replaceWith(iconWrapper);
    }
}

XpandUploadControl.prototype.updateDropzoneClass = function ($dropzone, fileCount) {
    if (fileCount > 0) {
        $dropzone.addClass("dropzone-container_highlight");
    } else {
        $dropzone.removeClass("dropzone-container_highlight");
    }
}

XpandUploadControl.prototype.clearCountError = function ($dropzone) {
    $dropzone.find('.field-validation-error').remove();
}

XpandUploadControl.prototype.GetAttr = function () {
    var self = this;
    var $elem = $(self.kendoUpload.element);
    for (var i = 0; i < arguments.length; i++) {
        var aval = $elem.attr(arguments[i]);
        if (aval) return aval;
        aval = $(self.ValueControl).attr(arguments[i]);
        if (aval) return aval;
    }
    return null;
}

XpandUploadControl.prototype.RegisterForEvents = function () {
    var self = this;
    self.ValueControl.on("before-save", function (e, data) {
        e.preventDefault();
        e.uploadControl = self;
        if (self.container && self.container.OnBeforeSave)
            return self.container.OnBeforeSave(e, data);
        setTimeout(function () {
            self.TryRemoveFiles(function () {
                if ($('.k-file.k-toupload', self.kendoUpload.wrapper).length === 0) {
                    self.SetCurrentValue();
                    if (e.ondone) e.ondone(e);
                } else {
                    var res = self.kendoUpload.upload();
                    self.kendoUpload.bind('complete', function (ev) {
                        self.SetCurrentValue();
                        if (e.ondone) e.ondone(e);
                    });
                }
            });
        }, 1);
    });

    //self.ValueControl.on("after-save", function (e, data, rdata) {
    //    self.settings.value = self.ValueControl.val();
    //    self.SetupCurrentValue();
    //});

    $(document).off('click.upload').on('click.upload', function (e) {
        var $target = $(e.target);
        if ($target.closest('.k-upload-button').length || $target.closest('.k-upload-files').length) {
            return;
        }

        if ($target.closest('.k-file-download-all').length) {
            e.preventDefault();
            return;
        }

        if ($target.closest('.k-dropzone').length) {
            $target.closest('.k-upload').toggleClass('show');
            return;
        }

        $('.k-upload').removeClass('show');
    });
};

XpandUploadControl.prototype.TryRemoveFiles = function (callback) {
    var self = this;

    var currentFiles = self.kendoUpload.getFiles();
    if (self.settings.files.length < 1) {
        callback();
        return;
    }
    var itemsToRemove = self.settings.files.filter(function (arrElement) {
        return !currentFiles.some(function (currentFile) {
            return (currentFile.dst && currentFile.dst.toLowerCase() == arrElement.dst.toLowerCase());
        });
    });

    self.RemoveFiles(itemsToRemove)
        .fail(function (e) {
            self.Error("can't remove files", e);
        })
        .then(function () {
            callback();
        });
};

XpandUploadControl.prototype.RemoveFiles = function (files) {
    var self = this;
    var result = $.Deferred();
    if (!files || files.length < 1) result.resolve();
    else {
        var items = files.map(f => f.name);
        self.kendoUpload._submitRemove(items, {
            data: {
                cnfr: 1
            }
        }, function () {
            result.resolve();
        }, function () {
            result.reject();
        });
    }
    return result;
};

XpandUploadControl.prototype.DownloadAllLink = function ($elem) {
    var template = document.getElementById('fileDownloadAllTemplate_' + $elem.data('value-id'));
    if (template) {
        var $parent = $elem.closest('.k-upload');
        $parent.find('.k-dropzone').append(template.innerHTML);
    }

};

XpandUploadControl.prototype.ImagesInit = function ($elem, event) {
    var $parent = $elem.closest('.upload-image-container');
    if (!$parent.length) {
        return;
    }

    var $cnt = $parent.find('.k-upload-files');
    var isSlider = $parent.hasClass('upload-slider');
    let height = $parent.attr('data-height');
    var hasHeight = height && parseInt(height) > 0;
    $cnt.find('.k-toupload img').attr('src', '/content/images/image-not-uploaded.png');
    if (hasHeight && !isSlider) {
        $cnt.css({ 'height': parseInt(height) + 37, 'overflow-y': 'auto' });
        $cnt.addClass('custom-scroll-vertical');
    }

    var widthClasses = $parent.data('width-classes');
    if (!isSlider) {
        $cnt.addClass('row').addClass('files-count-' + $cnt.children().length);
        $cnt.children().addClass(widthClasses);
        return;
    }

    if ($cnt.hasClass('slick-initialized')) {
        $cnt.slick('unslick');
    }

    if (event) {
        event.sender.wrapper.find('[data-uid="' + event.files[0].uid + '"]').remove();
    }

    var slidesToShow = XPortal.Utils.getViewportStateByClasses(widthClasses).map(function myFunction(num) {
        return num;
    });

    if (hasHeight) {
        var checkWidthTimeout = null;
        var checkWidth = function (slides) {
            slides.each(function () {
                var $this = $(this);
                $this.css({ 'max-width': $this.closest('.upload-control-element').outerWidth() });
            });
        }

        $cnt.on('init', function (event, slick) {
            checkWidth(slick.$slides);
            slick.$slides.length == 1 && slick.$slides.css({ 'width': '100%' });

            $(window).on('resize', function () {
                clearTimeout(checkWidthTimeout);
                checkWidthTimeout = setTimeout(function () {
                    checkWidth(slick.$slides);
                }, 150);
            });
        });
    }

    $cnt.slick({
        variableWidth: false,
        infinite: false,
        autoplay: false,
        useTransform: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow: "<span class='slider-arrow slider-prev'><i class='icon-arrow-left'></i></span>",
        nextArrow: "<span class='slider-arrow slider-next'><i class='icon-arrow-right'></i></span>"
    });
};

XpandUploadControl.prototype.UpdateUploadCustomFileNames = function ($elem, event) {
    const self = this;
    var $parent = $elem.closest('.k-upload');
    var files = self.kendoUpload.getFiles();
    const values = files && files.length ? files.filter(f => f.dst) : [];
    var fileNames = values.map(f => XPortal.UploadFiles.AdjustFileNameBeforeRender(f));
    fileNames = (fileNames || []).filter(x => x);
    var $downloadBtn = $parent.find('.k-file-download-all');
    var $uploadFilesNum = $downloadBtn.find('.k-upload-files-number');

    const truncateMiddle = (str, maxLen = 24) => {
        if (!str || str.length <= maxLen) return str;
        const separator = "...";
        const charsToShow = maxLen - separator.length;
        const frontChars = Math.ceil(charsToShow / 2);
        const backChars = Math.floor(charsToShow / 2);
        return str.substr(0, frontChars) + separator + str.substr(str.length - backChars);
    };

    if (fileNames.length > 0) {
        $downloadBtn.removeClass('d-none');
        $uploadFilesNum.html(fileNames.length);
    }
    else {
        $downloadBtn.addClass('d-none');
    }

    var processedNames = (fileNames || []).map(name => {
        const shortName = truncateMiddle(name, 14);
        return `<span title="${name}">${shortName}</span>`;
    });

    var $fileList = $('<a />', {
        class: 'k-file-list-custom',
        html: !fileNames.length && $elem.data('editable') === 0
            ? $elem.data('no-files-text')
            : $elem.closest('.upload-image-container').length
                ? ""
                : processedNames.join('; ')
    });
    $parent.find('.k-file-list-custom').remove();
    $fileList.insertAfter($parent.find('.k-file-download-all'));

    this.ImagesInit($elem, event);
};

XPortal.UploadFiles = (function () {
    var self = {
        ControlSelector: ".upload-file-container",
        Controls: [],
        BindControlValues: function () {
            var self = this;
            for (var i = 0, len = self.Controls.length; i < len; i++) {
                self.Controls[i].SetCurrentValue();
            }
        },
        Init: function (container) {
            var self = this;
            var modelName = XPortal.Store.getModelName(container[0].id);
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            self.Controls = (self.Controls && self.Controls.length) ? self.Controls : [];
            container.find(XPortal.UploadFiles.ControlSelector).each(function () {
                var dZone = $(this).parent('.k-dropzone');
                self.Controls.push(self.initFor(this, modelName, false, dZone));
            });
            $(document).on("popup:dispose", self.DisposeInPopup);
            const $dwndFrm = $("#downloadFrm");
            if ($dwndFrm) {
                const frmStgs = XPortal.Main.GetSettingsFor($dwndFrm);
                $dwndFrm.off("load");
                $dwndFrm.on("load", function (e) {
                    const frm = $dwndFrm[0];
                    if (frm.contentDocument) {
                        var ifTitle = frm.contentDocument.title;
                        if (ifTitle.indexOf("404") >= 0) {
                            XPortal.Modal.alert({
                                headerText: frmStgs["download-error"] || "Download error",
                                alertText: frmStgs["download-error-message"] || "An error occurred while downloading the file."
                            });
                        }
                    }
                });
            }
        },
        initFor: function (domEl, modelName, isInlineEditor = false, dropZone) {
            return new XpandUploadControl(this, $(domEl), modelName, isInlineEditor, dropZone);
        },
        OnDownloadFile: function (existOrNew, anch, fileUid, entityUid, alias, nodeId, fieldName, args) {
            if (args && args[0]) args[0].preventDefault();
            $('html').data('showprogress', 'no');
            anch = $(anch);
            var token = $('input[name="__RequestVerificationToken"]').first().val();

            if (anch.hasClass('k-file-download-all')) {
                XPortal.UploadFiles.frmSubmit('/umbraco/Surface/Detail/DownloadAllAttachments', {
                    id: [entityUid],
                    KeyField: fieldName,
                    NodeId: nodeId,
                    rid: nodeId,
                    __RequestVerificationToken: token
                }, null, null, 'downloadFrm');

                return;
            }

            var editor = anch.closest(".files.xpand-upload-files.xpand-multiselect");
            if (!editor)
                editor = anch.find(".files.xpand-upload-files.xpand-multiselect");

            var i = editor.attr("data-detail-id");
            var li = anch.closest(".k-file");
            if (!li)
                li = anch.find(".k-file");
            var data = li.data("files");
            if (!data || data.length < 1 || String(data[0].existing) !== "1") return false;

            var fle = data[0].dst ? data[0].dst : data[0].name;

            XPortal.UploadFiles.frmSubmit('/umbraco/Surface/Detail/DownloadFile', {
                i: entityUid,
                a: alias,
                src: nodeId,
                cnfr: 1,
                file: fle,
                f: fieldName,
                __RequestVerificationToken: token
            }, null, null, 'downloadFrm');

            return false;
        },
        GetDirectLink: function (file, entityUid, alias, nodeId, fieldName, args) {
            var i = file[0].uid;
            var data = file;
            if (!data || data.length < 1 || String(data[0].existing) !== "1") return '/content/images/image-not-uploaded.png';
            if (file[0].justUploaded)
                return self.GetBase64Link(file[0], args);

            var token = $('input[name="__RequestVerificationToken"]').first().val();
            var fle = data[0].dst ? data[0].dst : data[0].name;
            const defaultImgPath = self.isDarkTheme ? "/content/images/empty-content-view-item_tr_dark.png" : "/content/images/empty-content-view-item_tr.png"

            var fquery = $.param({
                i: entityUid,
                a: alias,
                src: nodeId,
                cnfr: 1,
                file: fle,
                f: fieldName,
                altr: defaultImgPath,
                __RequestVerificationToken: token
            });
            var r = '/umbraco/Surface/Detail/ImageAltr?' + fquery;
            return r;
        },
        GetBase64Link: function (file, args) {
            if (!file) return;
            const url = URL.createObjectURL(file.rawFile);
            return url;
        },
        frmSubmit: function (path, params, method, atttype, target, simpleform) {
            method = method || "post";
            target = target || "_self";

            var form = document.createElement("form");
            var frm = $(form);
            form.setAttribute("method", method);
            form.setAttribute("action", path);
            form.setAttribute("target", target);
            if (!simpleform) form.enctype = "multipart/form-data";
            //Move the submit function to another variable
            //so that it doesn't get overwritten.
            form._submit_function_ = form.submit;

            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", "atttype");
            hiddenField.setAttribute("value", atttype || "zip");

            $(hiddenField).appendTo(frm);

            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var value = params[key];
                    if (Array.isArray(value)) {
                        value.forEach(function (item) {
                            hiddenField = document.createElement("input");
                            hiddenField.setAttribute("type", "hidden");
                            hiddenField.setAttribute("name", key);
                            hiddenField.setAttribute("value", item);

                            $(hiddenField).appendTo(frm);
                        });
                    }
                    else {
                        hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", value);

                        $(hiddenField).appendTo(frm);
                    }
                }
            }
            frm.appendTo($(document.body));
            try {
                form._submit_function_();
            } catch (ex) {
                if (console && console.log) console.log(ex);
            }
            setTimeout(function () {
                try {
                    form.remove();
                } catch (ex) {
                    if (console && console.log) console.log(ex);
                }
            }, 5000);
        },
        AdjustFileNameBeforeRender: function (item) {
            var name = item.name;
            var ss = name.split('/');
            return ss[ss.length - 1];
        },
        UpdateGridRow: function (e, fInfo) {
            var dZoneCtrl = self.Controls.filter(f => f.settings.dropzone == e.sender.options.dropZone);
            if (!dZoneCtrl || !dZoneCtrl.length) {
                dZoneCtrl = [e.sender];
            }

            if (!dZoneCtrl || !dZoneCtrl.length) {
                console.error("Upload file can't be saved. No drop control in collection");
                XPortal.Loader.hide({ showOverlay: true });
                return;
            };
            var gridInfo;
            if (dZoneCtrl[0].relatedKGrid) {
                if (!dZoneCtrl[0].relatedKGrid.kgrid && dZoneCtrl[0].relatedKGrid.grid) {
                    dZoneCtrl[0].relatedKGrid = XPortal.Grid.GetGridInfo(dZoneCtrl[0].relatedKGrid.grid);
                }
                gridInfo = dZoneCtrl[0].relatedKGrid.kgrid;
            }
            if (!gridInfo) {
                XPortal.Loader.hide({ showOverlay: true });
                return;
            }

            const fNames = JSON.parse(dZoneCtrl[0].settings.fieldsnames);
            const modelName = dZoneCtrl[0].relatedKGrid.modelName;
            const autsaveTime = XPortal.Store.GetModelByName(modelName).model.autoSaverTimeOut;
            const omitAutoSave = false;// !(autsaveTime > 0);
            const updateGrid = true;
            var modifyNewRec = function (record) {
                fInfo.filename = fInfo.name.substring(0, fInfo.name.lastIndexOf('.'), omitAutoSave);
                XPortal.Store.DispatchByName(modelName, fNames.attachedfile, fInfo.dst, omitAutoSave);
                XPortal.Store.DispatchByName(modelName, fNames.filesize, fInfo.size, omitAutoSave);
                XPortal.Store.DispatchByName(modelName, fNames.fileextension, fInfo.extension, omitAutoSave);
                XPortal.Store.DispatchByName(modelName, fNames.filename, fInfo.filename, omitAutoSave, updateGrid);
                record[fNames.attachedfile] = fInfo.dst;
                record[fNames.filesize] = fInfo.size;
                record[fNames.fileextension] = fInfo.extension;
                record[fNames.filename] = fInfo.filename;

                record.dirty = true;
            };
            XPortal.GridInlineEditing.AddInlineRecord(dZoneCtrl[0].relatedKGrid.grid, modifyNewRec, true).then(() => {

                if (!self.Controls || !self.Controls.length) return;
                const curCtrl = self.Controls.filter(f => f.kendoUpload == e.sender);
                if (!curCtrl || !curCtrl.length) {
                    console.warn("Can't find control " + e.sender.name + " to finish upload process.");
                    return;
                }
                curCtrl[0].UploadingCount--;

                if (!curCtrl[0].UploadingCount) {
                    XPortal.Store.SaveStoreItemsDefer(true).then(() => {
                        XPortal.Store.ClearItemToSave(XPortal.Store.GetModelByName(modelName));
                        gridInfo.dataSource.read();
                        gridInfo.refresh();

                        XPortal.Loader.hide({ showOverlay: true });
                        XPortal.Modal.alert({
                            headerText: dZoneCtrl[0].settings.localization.filesUploadedTitle || "Upload files",
                            alertText: dZoneCtrl[0].settings.localization.filesUploadedMessage || "File(s) have been uploaded successfully."
                        });
                    });
                };
            });
        },
        DisposeInPopup: function (e, data) {
            self.Controls = self.Controls.filter(c => c.modelName != data.popupRootModelName);
        }
    };
    self.onDropZoneClick = function (del, inputName) {
        const elInput = $("input[name='" + inputName + "']");
        elInput[elInput.length - 1].click();
    };
    return self;
}());